var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reminder-table',{attrs:{"resource-name":"employee","resource-id":_vm.employeeData.id},on:{"refetch-data":function($event){return _vm.emit('refetch-data')}}})}
var staticRenderFns = []

export { render, staticRenderFns }